import { ca } from '@cian/analytics';

import { TCallbackOpener } from '../../types/callbackPopup';

interface ITrackCallbackOpenParams {
  label: string;
  placeType: TCallbackOpener;
}

export function trackCallbackOpen({ label, placeType }: ITrackCallbackOpenParams) {
  ca('eventSite', {
    action: `CallBack_popup_open_${placeType}`,
    category: 'Card',
    label,
    name: 'oldevent',
    useLastProducts: true,
  });
}
